import React, { Component } from 'react'
import { createPortal } from 'react-dom'

export default class Aside extends Component {
  render() {
    const { children, onClose = false, ...props } = this.props

    return createPortal(
        <div className="fixed bottom-0 inset-x-0 p-4 sm:inset-0 sm:flex justify-end z-50" {...props}>
          <div className="fixed inset-0 transition-opacity" onClick={onClose}>
            <div className="absolute inset-0 bg-gray-300 opacity-50"></div>
          </div>
          <div className="bg-white rounded-sm overflow-hidden shadow transform transition-all w-full sm:w-1/3 md:1/4 max-w-screen-sm">
            { children }
          </div>
        </div>,

      document.getElementById("react_app_modal"),
    );
  }
}
